import {useGTMDispatch} from './react-gtm-hook/index'
import {useSlotLocation} from './utils'
import {usePromotionTrackingRegistry} from './promotion-tracking-context'

export const useViewPromotionTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const location = useSlotLocation()
  const {registerTrackedPromotions} = usePromotionTrackingRegistry()

  return (promotions) => {
    const promotionItems = promotions.map((promotion) => ({
      ...promotion,
      creative_slot: `${location}_${promotion.creative_slot ?? ''}`
    }))

    registerTrackedPromotions(promotionItems)

    setTimeout(() => {
      sendDataToGTM?.({
        event: 'view_promotion',
        ecommerce: {
          items: promotionItems
        }
      })
    }, 0)
  }
}
